function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: -0.106,
  x2: 0.5,
  y2: 3.557,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "boxes",
  transform: "translate(-249 -363)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  transform: "translate(249 363)",
  fill: "#1f1f1f",
  stroke: "#1f1f1f",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 23,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.25,
  y: 1.25,
  width: 21.5,
  height: 20.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 8.5,
  height: 18,
  transform: "translate(251.5 365.5)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 8.5,
  height: 7.5,
  transform: "translate(262 365.5)",
  fill: "#4fdbff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 8.5,
  height: 3,
  transform: "translate(262 375)",
  fill: "#28afea"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 8.5,
  height: 3.5,
  transform: "translate(262 380)",
  fill: "#0078d4"
}));

function SvgBoxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.bfe82433.svg";
export { ForwardRef as ReactComponent };